import React from 'react';

// Грешка в чата не бива да сваля екрана на задачите — парчето на чата просто изчезва (или показва `fallback`).
class ChatErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    const { failed } = this.state;
    const { children, fallback = null } = this.props;
    return failed ? fallback : children;
  }
}

const withChatBoundary = Component => props => (
  <ChatErrorBoundary>
    <Component {...props} />
  </ChatErrorBoundary>
);

export { ChatErrorBoundary, withChatBoundary };
